import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions, asyncGetThermograms } from '../../../../model';
import styles from './style.css';
import hotRender, { clearAllThermograms } from './hotRender';

class HotList extends React.PureComponent {
    static propTypes = {
        uiStateUpdate: PropTypes.func,
        thermograms: PropTypes.array,
        autoRefreshThermogram: PropTypes.bool,
        thermogramListIsShow: PropTypes.bool,
        autoFixedThermogram: PropTypes.bool,
        isThermogram: PropTypes.bool,
        asyncGetThermograms: PropTypes.func,
        isClearThermogram: PropTypes.bool,
        thermogramListIsMini: PropTypes.bool,
    };

    async componentDidMount() {
        window.addEventListener('resize', this.hotRender, false);

        const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        // 选择目标节点
        const target = document.querySelector('#root');

        // 创建观察者对象
        this.observer = new MutationObserver(mutations => {
            if (!this.props.autoFixedThermogram) {
                return false;
            }
            let isRealChange = false;

            for (const mutation of mutations) {
                if (mutation.type === 'childList') {
                    if (
                        (mutation.addedNodes.length > 0 &&
                            mutation.addedNodes[0].classList.contains('statistics-inner-box')) ||
                        (mutation.removedNodes.length > 0 &&
                            mutation.removedNodes[0].classList.contains('statistics-inner-box'))
                    ) {
                        continue;
                    }
                }
                isRealChange = true;
                break;
            }

            if (isRealChange) {
                setTimeout(() => {
                    this.hotRender();
                }, 5000);
            }
        });

        const config = { attributes: true, childList: true, characterData: true, subtree: true };

        // 传入目标节点和观察选项
        this.observer.observe(target, config);

        this.timer = setInterval(async () => {
            if (this.props.autoRefreshThermogram && this.props.isThermogram) {
                await this.props.asyncGetThermograms();
                this.hotRender();
            }
        }, 60 * 1000);

        if (this.props.isThermogram) {
            await this.props.asyncGetThermograms();
            hotRender();
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        window.removeEventListener('resize', this.hotRender);
    }

    hotRender = () => {
        // console.log('this.props.isThermogram', this.props.isThermogram);
        if (this.props.isThermogram) {
            hotRender();
        }
    };

    refreshThermogramPageHandle = () => {
        window.location.reload();
    };

    autoRefreshThermogramHandle = () => {
        this.props.uiStateUpdate({
            autoRefreshThermogram: !this.props.autoRefreshThermogram,
        });
    };

    autoFixedThermogramHandle = () => {
        this.props.uiStateUpdate({
            autoFixedThermogram: !this.props.autoFixedThermogram,
        });
    };

    refreshThermogramDataHandle = async () => {
        await this.props.asyncGetThermograms();
        hotRender();
    };

    clearThermogramHandle = () => {
        if (!this.props.isClearThermogram) {
            clearAllThermograms();
        } else {
            hotRender();
        }
        this.props.uiStateUpdate({
            isClearThermogram: !this.props.isClearThermogram,
        });
    };

    thermogramListMiniHandle = () => {
        this.props.uiStateUpdate({
            thermogramListIsMini: !this.props.thermogramListIsMini,
        });
    };
    renderMini() {
        const updateTime = this.props.thermograms[0] ? this.props.thermograms[0].TM : '';

        return (
            <React.Fragment>
                <f-div class={styles.miniTime}>{updateTime}</f-div>
                <f-div
                    onClick={this.refreshThermogramPageHandle}
                    class={styles.refreshThermogramPage}
                    title="刷新页面"
                />
                <f-div
                    onClick={this.autoRefreshThermogramHandle}
                    class={
                        this.props.autoRefreshThermogram
                            ? styles.thermogramAutoRefreshActive
                            : styles.thermogramAutoRefresh
                    }
                    title={`自动刷新(${this.props.autoRefreshThermogram ? '点击关闭' : '点击开启'})`}
                />
                <f-div
                    onClick={this.autoFixedThermogramHandle}
                    class={
                        this.props.autoFixedThermogram ? styles.thermogramAutoFixedActive : styles.thermogramAutoFixed
                    }
                    title={`自动矫正(${this.props.autoFixedThermogram ? '点击关闭' : '点击开启'})`}
                />
                <f-div
                    onClick={this.clearThermogramHandle}
                    class={this.props.isClearThermogram ? styles.clearThermogram : styles.clearThermogramActive}
                    title={`${this.props.isClearThermogram ? '隐藏' : '显示'}热图(${
                        this.props.isClearThermogram ? '点击显示' : '点击隐藏'
                    })`}
                />
                <f-div
                    onClick={this.refreshThermogramDataHandle}
                    class={styles.refreshThermogramData}
                    title="刷新数据"
                />{' '}
            </React.Fragment>
        );
    }

    renderFull() {
        const updateTime = this.props.thermograms[0] ? this.props.thermograms[0].TM : '';

        return (
            <React.Fragment>
                {updateTime ? (
                    <f-div style={{ textAlign: 'center' }}>
                        数据更新时间<f-div class={styles.thermogramUpdateTime}>{updateTime}</f-div>
                    </f-div>
                ) : null}
                <f-div onClick={this.refreshThermogramPageHandle} class={styles.refreshThermogramPage}>
                    刷新页面
                </f-div>
                <f-div
                    onClick={this.autoRefreshThermogramHandle}
                    class={
                        this.props.autoRefreshThermogram
                            ? styles.thermogramAutoRefreshActive
                            : styles.thermogramAutoRefresh
                    }>
                    自动刷新({this.props.autoRefreshThermogram ? '点击关闭' : '点击开启'})
                </f-div>
                <f-div
                    onClick={this.autoFixedThermogramHandle}
                    class={
                        this.props.autoFixedThermogram ? styles.thermogramAutoFixedActive : styles.thermogramAutoFixed
                    }>
                    自动矫正({this.props.autoFixedThermogram ? '点击关闭' : '点击开启'})
                </f-div>

                <f-div
                    onClick={this.clearThermogramHandle}
                    class={this.props.isClearThermogram ? styles.clearThermogram : styles.clearThermogramActive}>
                    {this.props.isClearThermogram ? '隐藏' : '显示'}热图({this.props.isClearThermogram
                        ? '点击显示'
                        : '点击隐藏'})
                </f-div>
                <f-div onClick={this.refreshThermogramDataHandle} class={styles.refreshThermogramData}>
                    刷新数据
                </f-div>
                <f-div class={styles.legend}>
                    <f-div class={styles.legendTitle}>点击率</f-div>
                    <f-div class={styles.legendInfo1}>&gt; 10%</f-div>
                    <f-div class={styles.legendInfo2}>&gt; 5%</f-div>
                    <f-div class={styles.legendInfo3}>&gt; 1-5%</f-div>
                    <f-div class={styles.legendInfo4}>&lt; 1%</f-div>
                </f-div>
                <f-div class={styles.info}>
                    <f-div class={styles.infoHeader}>数据说明</f-div>
                    <f-div class={styles.infoInner}>
                        1.展示最近1分钟的点击数据，与统计系统中“实时-首页点击排行”中的数据完全一致；
                    </f-div>
                    <f-div class={styles.infoInner}>
                        2.统计依据为url地址，因此相同地址的数据会完全一样，点进数据与页面位置并不是严格一一对应；
                    </f-div>
                    <f-div class={styles.infoInner}>3.不监测广告类链接地址以及html5页面地址；</f-div>
                    <f-div class={styles.infoInner} style={{ color: 'red' }}>
                        4.自动矫正可能会造成页面卡顿，默认为关闭，如果热图错位，可以点击刷新数据进行修复；
                    </f-div>
                    <f-div class={styles.infoInner} style={{ color: 'red' }}>
                        5.点击右下角火焰图标返回可视化编辑状态；
                    </f-div>
                </f-div>
            </React.Fragment>
        );
    }

    judgeListClass() {
        if (this.props.thermogramListIsShow) {
            if (this.props.thermogramListIsMini) {
                return styles.listContainerMini;
            } else {
                return styles.listContainerShow;
            }
        } else {
            return styles.listContainer;
        }
    }
    render() {
        return (
            <f-div class={this.judgeListClass()}>
                <f-div
                    onClick={this.thermogramListMiniHandle}
                    class={this.props.thermogramListIsMini ? styles.arrowOpen : styles.arrowClose}
                    title={this.props.thermogramListIsMini ? '展开菜单' : '收起菜单'}
                />
                {this.props.thermogramListIsMini ? this.renderMini() : this.renderFull()}
            </f-div>
        );
    }
}

const mapStateToProps = state => ({
    thermogramListIsShow: state.uiState.thermogramListIsShow,
    autoRefreshThermogram: state.uiState.autoRefreshThermogram,
    autoFixedThermogram: state.uiState.autoFixedThermogram,
    thermograms: state.thermograms,
    isThermogram: state.uiState.isThermogram,
    isClearThermogram: state.uiState.isClearThermogram,
    thermogramListIsMini: state.uiState.thermogramListIsMini,
});

const mapDispatchToProps = dispatch => ({
    uiStateUpdate: value => dispatch(actions.uiStateUpdate(value)),
    asyncGetThermograms: () => dispatch(asyncGetThermograms()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(HotList);
